module.exports = __webpack_public_path__ + "img/tu1.a26f84c4.png";